import axios from "axios";
import { API_URL } from "../constants";

export const fetchById = (companyId, id) => {
  const url = `${API_URL}/${companyId}/emails/${id}`;
  return axios.get(url).then((response) => response.data);
};

export const resendEmail = (companyId, id) => {
  const url = `${API_URL}/${companyId}/emails/${id}/resend`;
  return axios.post(url).then((response) => response.data);
};
